import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import ImageUploadField from 'components/organisms/ImageUpload/ImageUploadField'
import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    textAlign: 'center',
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  uploadLogoTitle: {
    fontSize: 14,
    textAlign: 'left',
    marginTop: theme.spacing(2),
  },
  imageUpload: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px 0`,
  },
})

const CreateOrganisationForm = ({
  errors,
  status,
  values,
  classes,
  isSubmitting,
  errorMessage,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  handleImageChange,
  handleImageRemoved,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          className={classes.errorMessage}
          color="error"
          align="center">
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('name')}>
          <TextField
            id="name-input"
            name="name"
            label="Project name"
            value={values.name}
            onChange={handleFieldChange}
            type="name"
            autoComplete="name"
            error={hasFieldError('name')}
            margin="normal"
            inputProps={{
              maxLength: 1024,
            }}
          />
          {hasFieldError('name') ? (
            <FormHelperText>{errors.name}</FormHelperText>
          ) : null}
        </FormControl>
          {/*
        <Typography className={classes.uploadLogoTitle} variant="h3">
          Upload project logo
        </Typography>
        <FormControl
          className={classNames(classes.formControl, classes.imageUpload)}
          fullWidth
          error={hasFieldError('image')}>
          <ImageUploadField
            name="image"
            helperText="240px by 180px works best"
            onRemove={handleImageRemoved}
            onSelect={handleImageChange}
            error={errors.image}
          />
          {hasFieldError('image') ? (
            <FormHelperText error>{errors.image}</FormHelperText>
          ) : null}
        </FormControl>
        */}
        <FormControl className={classes.formControl} fullWidth>
          <SubmitButton
            autoFocus
            size="large"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}>
            Create project
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

CreateOrganisationForm.propTypes = {
  onLogin: PropTypes.func,
  errors: PropTypes.object,
  status: PropTypes.string,
  values: PropTypes.object,
  rememberMe: PropTypes.bool,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  apiCallError: PropTypes.bool,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  handleImageChange: PropTypes.func,
  handleImageRemoved: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func,
}

export default withStyles(styles)(CreateOrganisationForm)



// WEBPACK FOOTER //
// ./src/components/organisms/CreateOrganisationForm/CreateOrganisationForm.js